<!--供应商订单详情页面-->
<template>
  <el-dialog :title="pcustomer" :visible.sync="dialogstoreVisible" custom-class="full-dialog" center :append-to-body="true"
             :close-on-click-modal="false" @close="closeDialog">
    <div ref="print1">
      <el-row>
        <div class="search-content">
          <el-row class="toobar" :gutter="5">
            <el-col :span="19">
              <el-select v-model="datetype" placeholder="请选择" @change="changetype" style="width: 100px" size="mini">
                <el-option
                  v-for="item in datetypes"
                  :key="item.item"
                  :label="item.name"
                  :value="item.item">
                </el-option>
              </el-select>
              <el-date-picker size="mini"
                v-model="searchdatevalue" v-if="datetype==1" @change="bindGrid"
                type="month" :value-format="'yyyyMM'" style="width:120px;"
                placeholder="选择年月">
              </el-date-picker>
              <el-date-picker size="mini"
                style="width: 240px"
                v-model="searchdatevalue1"
                type="daterange" :value-format="'yyyy-MM-dd'"
                align="left" :unlink-panels="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions2" v-if="(datetype==2 || datetype==3)&&!priceSub">
              </el-date-picker>
              <el-input placeholder="请选择供应商" v-model="pcustomer" size="mini" style="width:160px;"
                        @click.native="showSelectAllPCustomer" v-if="!priceSub"></el-input>
              <el-select v-model="searchstatus" placeholder="请选择状态" style="width:120px;"  size="mini">
                <el-option
                  v-for="item in statusdata"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-input placeholder="选品牌" v-model="categoryname" clearable style="width: 100px"  size="mini"
                                      @click.native="showCategoryDetailSel"
                                      @clear="clearCategory"></el-input>
              <el-input placeholder="请选择商品" v-model="seedname" clearable @click.native="showGoodDetailSel" size="mini"
                        style="width:160px;"
                        @clear="clearSeedCode">
              </el-input>
              <el-input auto-complete="off" v-model="searchtext" @keyup.native="UpNumber" placeholder="销售或采购单号" style="width:140px;" size="mini"
                        clearable></el-input>
              <el-input auto-complete="off" v-model="tracknum" @keyup.native="UpNumber" placeholder="供应商单号" style="width:140px;" size="mini"
                        clearable></el-input>
              <!--<el-input auto-complete="off" v-model="logisticstracknum" placeholder="跟踪号" style="width:140px;"-->
                        <!--clearable></el-input>-->
              <el-select v-model="cangkucode" @change="bindGrid()" filterable style="width: 140px" size="mini">
                <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                           :label="item.cangkuname"
                           :value="item.cangkucode">
                </el-option>
              </el-select>
              <el-checkbox v-model="showPackageSize" @change="showPas">显示度数</el-checkbox>
              <!--<el-input auto-complete="off" v-model="Y" placeholder="球镜" style="width:120px;" v-if="showPackageSize"-->
                        <!--clearable></el-input>-->
              <!--<el-input auto-complete="off" v-model="X" placeholder="柱镜" style="width:120px;" v-if="showPackageSize"-->
                        <!--clearable></el-input>-->
            </el-col>
            <el-col :span="5" style="text-align: left;padding-right: 30px">
              <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)" v-if="false"/>
              <el-button type="primary" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
              <!--<el-button type="warning" v-on:click="importEdit" v-if="!searchdatevalue&&false">导入对账</el-button>-->
              <el-button type="primary" @click="excelPort" size="mini" v-if="!allowSelect&&loadexcel">导出</el-button><br>
              <el-button type="success"   @click="changeVerifyAll(1)" v-if="hedui" size="mini">核对全部</el-button>
              <el-button type="infor"  @click="changeVerifyAll(0)" v-if="hedui" size="mini">取消核对</el-button>
              <!--<el-button type="warning" v-on:click="showSelDate" v-if="!searchdatevalue&&!priceSub">对账</el-button>-->
              <!--<el-button type="warning" v-on:click="computePrice" v-if="priceSub">计算返点</el-button>-->
              <!--<span style="margin-left: 40px;cursor: pointer;" @click="looklog" v-if="searchdatevalue&&!priceSub">(对账记录)</span>-->
            </el-col>
          </el-row>
        </div>
        <el-col :span="24">
          <div class="grid-content bg-purple-light">
            <el-table v-if="dialogstoreVisible"
                      :data="tableData"
                      :height="eltableheight"
                      size="mini"
                      show-summary
                      border :row-class-name="tableRowClassName"
                      :summary-method="getSummaries"
                      style="width: 100%;">
              <el-table-column
                width="60" fixed
                label="序号"
                align="center"
              >
                <template slot-scope="scope">
                  {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
                </template>
              </el-table-column>
              <el-table-column
                prop="erpserial"
                label="采购单号"
                align="center" fixed
                header-align="center" width="120">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.erpserial }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname" fixed :show-overflow-tooltip="true"
                label="产品名称"
                width="200"
                align="left" fixed
                header-align="center">
                <template slot-scope="scope">
                  {{ scope.row.seedname }}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedcode"
                label="产品编码"
                align="left"
                header-align="center"  :show-overflow-tooltip="true"
                width="70">
                <template slot-scope="scope">{{ scope.row.seedcode }}
                </template>
              </el-table-column>
              <el-table-column
                prop="leibie" :show-overflow-tooltip="true"
                label="类别"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="pinpai" :show-overflow-tooltip="true"
                label="品牌"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="xilie" :show-overflow-tooltip="true"
                label="系列"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column v-if="showPackageSize"
                               prop="packagesizeY"
                               label="球镜/规格"
                               align="right"
                               header-align="center"
                               width="105">
                <template slot-scope="scope">
                  {{getPackagesizeY(scope.row.packagesize)}}
                </template>
              </el-table-column>
              <el-table-column v-if="showPackageSize"
                               prop="packagesizeX"
                               label="柱镜/色号"
                               align="right"
                               header-align="center"
                               width="105">
                <template slot-scope="scope">
                  {{getPackagesizeX(scope.row.packagesize)}}
                </template>
              </el-table-column>
              <el-table-column
                label="数量"
                align="right"
                header-align="center"
                width="80"
                sortable
                prop="totalnumber">
                <template slot-scope="scope">
                  {{scope.row.totalnumber|numeric(0)}}
                </template>
              </el-table-column>
              <el-table-column
                label="采购单价"
                align="right" sortable prop="costprice" v-if="showcostprice"
                header-align="center"
                width="120">
                <template slot-scope="scope">
                  <span style="text-decoration:underline;cursor: pointer;" @click="updatecostpirce(scope.row)">{{scope.row.costprice|numeric(3,1)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="采购总额"
                align="right"
                sortable v-if="showcostprice"
                prop="costtotalmoney"
                header-align="center"
                width="120">
                <template slot-scope="scope">
                  {{scope.row.costtotalmoney|numeric(3,1)}}
                </template>
              </el-table-column>
              <el-table-column
                label="奖励"
                align="right"
                sortable v-if="showcostprice&&showcontract"
                prop="rebatemoney"
                header-align="center"
                width="100">
                <template slot-scope="scope">
                  {{scope.row.rebatemoney|numeric(2,1)}}
                </template>
              </el-table-column>
              <el-table-column
                label="返利"
                align="right"
                sortable v-if="showcostprice&&showcontract"
                prop="rebatepercent"
                header-align="center"
                width="100">
                <template slot-scope="scope">
                  {{scope.row.rebatepercent|numeric(3,1)}}
                </template>
              </el-table-column>
              <el-table-column
                label="实际金额"
                align="right"
                sortable v-if="showcostprice&&showcontract"
                prop="realmoney"
                header-align="center"
                width="100">
                <template slot-scope="scope">
                  {{scope.row.realmoney|numeric(3,1)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="handleoverdate"
                label="到货时间"
                sortable
                align="center"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.handleoverdate }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="htqd"
                sortable
                label="下单时间"
                align="center"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.htqd }}
                  </span>
                </template>
              </el-table-column>
              <!--<el-table-column-->
                <!--label="核算单价"-->
                <!--align="right" sortable prop="price"-->
                <!--header-align="center"-->
                <!--width="120">-->
                <!--<template slot-scope="scope">-->
                  <!--{{scope.row.price|numeric(3,1)}}-->
                <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
                <!--label="核算总额"-->
                <!--align="right"-->
                <!--sortable-->
                <!--prop="totalmoney"-->
                <!--header-align="center"-->
                <!--width="120">-->
                <!--<template slot-scope="scope">-->
                  <!--{{scope.row.totalmoney|numeric(3,1)}}-->
                <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column
                prop="cangkuname"
                label="仓库" :show-overflow-tooltip="true"
                align="left"
                header-align="center"
                width="100">
              </el-table-column>
              <el-table-column
                prop="hetongserial"
                label="销售单号"
                align="left"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  <span @click="lookdingdan(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.hetongserial}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="供应号"
                align="right"
                header-align="center" :show-overflow-tooltip="true"
                width="100"
                prop="tracknum">
                <template slot-scope="scope">
                  <span style="text-decoration:underline;cursor: pointer;" @click="changeGYH(scope.row)" v-if="!showPackageSize">
                    {{scope.row.tracknum?scope.row.tracknum:'  填写  '}}
                  </span>
                  <span v-else> {{scope.row.tracknum}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="对账备注" prop="remark"
                align="right"
                :show-overflow-tooltip="true"
                header-align="center"
                width="200">
                <template slot-scope="scope">
                  <div v-html="getLiuYan(scope.row.remark,null,'对账')"
                       style="text-align: left;padding-left: 5px;padding-right: 5px;" class="color-grey"></div>
                </template>
              </el-table-column>
              <el-table-column
                label="采购备注" prop="remark"
                align="right"
                :show-overflow-tooltip="true"
                header-align="center"
                width="200">
                <template slot-scope="scope">
                  <div v-html="getLiuYan(scope.row.remark,'对账')"
                       style="text-align: left;padding-left: 5px;padding-right: 5px;" class="color-grey"></div>
                </template>
              </el-table-column>
              <!--<el-table-column-->
                <!--label="销售单备注"-->
                <!--align="right"-->
                <!--header-align="center"-->
                <!--:show-overflow-tooltip="true"-->
                <!--width="200">-->
                <!--<template slot-scope="scope">-->
                  <!--<div v-html="getLiuYan(scope.row.hetongremark)"-->
                       <!--style="text-align: left;padding-left: 5px;padding-right: 5px;" class="color-grey"></div>-->
                <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column
                label="操作" fixed="right"
                align="right"
                header-align="center"
                width="160">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="setBeiZhu(scope.row)">备注
                  </el-button>
                  <el-button
                    size="mini"
                    @click="lookbuyorderdetail(scope.row)">查看
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="casestatus" fixed="right"
                label="核对" v-if="hedui"
                align="center"
                width="60">
                <template slot-scope="scope">
                  <el-button icon="el-icon-coordinate" v-if="showPackageSize" :type="scope.row.casestatus==1?'success':''" circle size="mini" :loading="vloading" @click="changeVerify(scope.row)"></el-button>
                  <el-button icon="el-icon-coordinate" v-else :type="scope.row.ordercasestatus==1?'success':''" circle size="mini" :loading="vloading" @click="changeVerify(scope.row)"></el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="选择" fixed="right"
                align="right" v-if="allowSelect"
                header-align="center"
                width="80">
                <template slot-scope="scope">
                  <el-button
                    size="mini" type="primary" @click="selectorder(scope.row)">选择
                  </el-button>
                </template>
              </el-table-column>
              <!--<el-table-column v-if="showduizhang"-->
              <!--fixed="right" :render-header="renderHeader"-->
              <!--width="70">-->
              <!--<template slot-scope="scope">-->
              <!--<el-checkbox :disabled="scope.row.casefvid!=null&&scope.row.casefvid!=''"-->
              <!--v-model="scope.row.casestatus==1" @change="changeDuiZhang(scope.row)"></el-checkbox>-->
              <!--</template>-->
              <!--</el-table-column>-->
            </el-table>
            <div class="foot">
              <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"
                          :showlagersize="true"></Pagination>
            </div>
          </div>
        </el-col>
      </el-row>
      <SelDate ref="SelDate" @afterselduizhangdate="confirmDuiZhang"></SelDate>
      <SelDateLog ref="SelDateLog"></SelDateLog>
      <BuyorderDetail ref="BuyorderDetail" @bindGrid="bindGrid"></BuyorderDetail>
      <ExternaldeptSel ref="externaldeptsel" @select="afterSelExternalDept"></ExternaldeptSel>
      <UpdateCostPrice ref="UpdateCostPrice" @afertupdate="afertupdate"></UpdateCostPrice>
      <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
      <CstagreementEdit ref="DataContactEdit" @bindGrid="bindGrid"></CstagreementEdit>
      <StorageBadOut ref="StorageBadOut"></StorageBadOut>
      <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
      <JxcgoodscategorySel ref="JxcgoodscategorySel" @afterSelectCode="afterSelectCategoryCode"></JxcgoodscategorySel>
    </div>
  </el-dialog>
</template>
<script>
  import {servicesub, supplierDeptList,supplierComputePrice, savetobalanceaccountlog} from '@/api/set/jiesuan';
  import {ConvertMoney, pickerShortCuts, getRemark} from '@/plugin/ordercommon';
  import {updateDuiZhang,printingbuy,updateStatus,saveCstagreementData,updateDetailbyunitguid} from '@/api/set/csagreement'
  import {independentDept} from '@/api/set/dept';
  import BuyorderDetail from '@/components/testorder/buyagreement/BuyorderDetail'
  import ExternaldeptSel from '@/components/set/externaldept/ExternaldeptSel'
  import UpdateCostPrice from '@/components/account/UpdateCostPrice';
  import SelDate from '@/components/account/SelDate';
  import SelDateLog from '@/components/account/SelDateLog';
  import JxcgooddetailSel from '../set/jxcgooddetail/JxcgooddetailSel'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import StorageBadOut from '@/components/warehouse/StorageBadOut'
  import BaoSunDetail from '@/components/testorder/cstagreement/BaoSunDetail';
  import JxcgoodscategorySel from '../set/jxcgoodscategory/JxcgoodscategorySel'

  export default {
    name: '',
    data() {
      return {
        text: {},
        temp: [],
        type: 'sale',
        eltableheight: 300,
        loadexcel:false,
        formLabelWidth: '120px',
        seen: false,
        dialogstoreVisible: false,
        showPackageSize: false,
        loading: true,
        priceSub:false,
        searchdatevalue: '',
        searchdatevalue1: '',
        htqd:'',
        jhjgrq:'',
        buycontractguid:'',
        tableData: [],
        tableDataExcel: [],
        subData: [],
        pickerOptions2: {
          shortcuts: []
        },
        pcustomerserial: '',
        pcustomer: '',
        applybydserial: '',
        showcontract:false,
        searchjxs: '',
        searchstatus: '',
        searchtext: "",//销售或者采购单号查询
        seedname: "",//查询条件显示
        categoryname:"",
        categorycode:"",
        seedcode: "",//查询条件显示
        canshowgoodsel: true,//解决清空事件与click的冲突问题
        Y: '',//球镜
        X: '',//柱镜
        pagination: {
          currentPage: 1,
          pageSize: 50,
          total: 0
        },
        jxsdata: [],
        statusdata: [{
          value: '',
          text: '订单状态'
        },
          {
            value: '1',
            text: '已到货'
          },
          {
            value: '-1',
            text: '未到货'
          },
          {
            value: '-2',
            text: '已退货'
          },
        ],
        datetypes: [
        //   {
        //   name: '按账单日期',
        //   item: 1
        // },
          {
          name: '按到货日期',
          item: 2
        },
          {
            name: '按下单日期',
            item: 3
          },
        ],
        datetype: 1,
        showzero:false,
        checkall: false,
        showduizhang: false,//为了实现对账全选复选框的效果
        userInfoModel: {},//缓存信息
        jxcstoreData: [],//仓库
        cangkucode: '',//选择后的仓库编码
        logisticstracknum: '',//跟踪单号
        tracknum: '',//供应商单号

      }
    },
    props:{
      showcostprice:{
        default:true
      },
      allowSelect:{
        default:false
      },
      hedui:{
        default:false
      }
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        if (this.showPackageSize) {
          if (row.casestatus == 1) {
            return 'success-row';
          }
        } else {
          if (row.ordercasestatus == 1) {
            return 'success-row';
          }
        }
        return '';
      },
      changeGYH(row){
        if(this.showPackageSize) return;
        this.$prompt('', '请输入供应号！', {
          inputValue: row.tracknum,
          confirmButtonText: '保存',
          cancelButtonText: '取消',
        }).then(({value}) => {
          row.tracknum= value;
          saveCstagreementData({unitguid: row.unitguid,tracknum:row.tracknum}).then(respMSG=>{
            this.$message({type: 'success',message: '保存成功！' });
          })
        }).catch(() => {
        });
      },
      changeVerifyAll(casestatus) {
        for (let i in this.tableData) {
          if (casestatus == 1) {
            if (this.tableData[i].casestatus == 1) {
              return;
            }
          } else {
            if (this.tableData[i].casestatus != 1) {
              return;
            }
          }
          this.changeVerify(this.tableData[i]);
        }
      },
      changeVerify(row) {
        if (this.showPackageSize) {
          if (!row.itemunitguid) return;
          this.vloading = true;
          var verify = row.casestatus == 1 ? 0 : 1;
          updateDetailbyunitguid({unitguid: row.itemunitguid, casestatus: verify}).then(respone => {
            this.vloading = false;
            row.casestatus = verify;
          });
        } else {
          if (!row.unitguid) return;
          this.vloading = true;
          var verify = row.ordercasestatus == 1 ? 0: 1;
          saveCstagreementData({unitguid: row.unitguid, casestatus: verify}).then(respone => {
            this.vloading = false;
            row.ordercasestatus = verify;
          });
        }
      },
      UpNumber(e) {
        if (e.keyCode == 13) {
          this.bindGrid();
        }
      },
      //显示商品类别选择页面
      showCategoryDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgoodscategorySel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //选择商品类别之后执行
      afterSelectCategoryCode(row) {
        this.categorycode = row.categorycode
        this.categoryname = row.categoryname
      },
      //清空商品le
      clearCategory() {
        this.categorycode = ''
        this.categoryname = ''
        this.canshowgoodsel = false
      },
      //根据登录人过滤仓库
      cusandptbyind() {
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          if (this.userInfoModel.independentserial == "") {//总部登录
            this.jxcstoreData.unshift({
              cangkuname: "全部仓库",
              cangkucode: ''
            })
          }
          this.cangkucode = this.jxcstoreData[0].cangkucode;
          this.bindGrid();
        })
      },
      getLiuYan(remark,excloudtype,showtype) {
        return getRemark(remark,excloudtype,showtype).replace(new RegExp("<br/>", "gm"), "");
      },
      showPas() {
        this.bindGrid();
      },
      closeDialog() {
        this.showduizhang = false
        this.$emit('bindGridClose');
      },
      changetype() {

      },
      computePrice() {
        supplierComputePrice({
          unitguid: this.buycontractguid
        }).then((response) => {
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              duration: 1500,
              message: '返点计算成功！'
            });
            this.bindGrid();
          }
        });
      },
      showSelDate() {
        this.loadData(true, true)
      },
      confirmDuiZhang(casefvid, accountdate, totalmoney, remark, arr) {
        updateDuiZhang({
          casefvid: casefvid,
          arr: JSON.stringify(arr),
          pcustomer: this.pcustomer,
          pcustomerserial: this.pcustomerserial,
          accountdate: accountdate,
          remark: remark
        }).then((response) => {
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              duration: 1500,
              message: '上传成功！'
            });
            this.bindGrid();
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            duration: 1500,
            message: '已取消'
          });
        });
      },
      renderHeader(h, {column, $index}) {
        return h("el-checkbox", {
          class: "duizhang",
          props: {
            checked: this.checkall,
            disabled: this.searchdatevalue != null && this.searchdatevalue != ""
          },
          nativeOn: {
            change: (event) => {
              this.checkall = event.target.checked
            }
          }
        }, [h("span", {style: {fontSize: "12px", fontFamily: "'Avenir', Helvetica, Arial, sans-serif"}}, "对账")])
      },
      /////////////////////////
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = false
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
      },

      getPackagesizeY(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);

        return ps.Y?ps.Y:ps.M;
      },
      getPackagesizeX(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);

        return ps.X?ps.X:ps.C;
      },
      excelPort() {
        if(this.pagination.total>50000){
          alert('记录数太多，不支持导出！');
          return;
        }
        this.loadData(true);
      },
      excelPortAfterLoad() {
        let data = []
        for (let i in this.tableDataExcel) {
          data.push(Object.assign({}, this.tableDataExcel[i]))
        }
        this.text = Object.assign({}, data[0])//浅拷贝，原始数组不变
        let header1 = ["采购单号", "销售单号", "供应商名称", "商品名称","类别","品牌","系列", "商品代码", "下单时间", "到货时间","仓库", "供应商单号", "跟踪号", "数量"]
        let column1 = ["erpserial", "hetongserial", "applybydname", "seedname","leibie","pinpai","xilie", "seedcode", "htqd", "handleoverdate","cangkuname", "tracknum", "logisticstracknum", "totalnumber"]


        if (this.showPackageSize) {
          header1.splice(4, 0, "球镜")
          header1.splice(5, 0, "柱镜")
          column1.splice(4, 0, "Y")
          column1.splice(5, 0, "X")
        }
        var name = this.pcustomer + (this.searchdatevalue || this.fmtDate(new Date()))
        let heji = {}
        let totalnumber = 0
        let totalmaney = 0
        let rebatemoney = 0
        let rebatepercent = 0
        let realmoney = 0
        for (let i = 0; i < data.length; i++) {
          data[i].remark2 = this.getLiuYan(data[i].remark,null,'对账')//对账
          data[i].remark = this.getLiuYan(data[i].remark,'对账')//采购单备注
          data[i].hetongremark = this.getLiuYan(data[i].hetongremark)//销售单备注
          totalnumber = totalnumber + data[i]["totalnumber"]
          totalmaney = totalmaney + (data[i]["costtotalmoney"] || 0)
          rebatemoney = rebatemoney + (data[i]["rebatemoney"] || 0)
          rebatepercent = rebatepercent + (data[i]["rebatepercent"] || 0)
          data[i].realmoney=this.getRealmoney(data[i]);
          realmoney = realmoney + (data[i]["realmoney"] || 0)

          data[i]["danjia"] = (data[i]['costtotalmoney'] / data[i]["totalnumber"]).toFixed(3)
          data[i]['costtotalmoney'] = (Math.round(data[i]['costtotalmoney'] * 1000) / 1000).toFixed(3)
          if (this.showPackageSize) {
            if (data[i]['packagesize'] != undefined && data[i]['packagesize'] != '') {
              data[i]['Y'] = JSON.parse(data[i]['packagesize']).Y
              data[i]['X'] = JSON.parse(data[i]['packagesize']).X
            } else {
              data[i]['Y'] = ''
              data[i]['X'] = ''
            }
          }
        }
        heji["erpserial"] = "合计"
        heji["totalnumber"] = totalnumber
        heji["costtotalmoney"] = (Math.round(totalmaney * 1000) / 1000).toFixed(3)
        heji["rebatemoney"] = rebatemoney
        heji["rebatepercent"] = rebatepercent
        heji["realmoney"] = realmoney
        data.push(heji)

        if(this.showcostprice){
          header1.push("单价");
          header1.push("采购总价");
          column1.push("danjia");
          column1.push("costtotalmoney");
          if(rebatemoney||rebatepercent){
            header1.push("奖励");
            header1.push("返利");
            header1.push("实际金额");
            column1.push("rebatemoney");
            column1.push("rebatepercent");
            column1.push("realmoney");
          }
        }
        header1.push("对账备注");
        column1.push("remark2");
        header1.push("采购单备注");
        column1.push("remark");

        this.$exportExcel(header1, column1, data, name)
      },
      fmtDate(obj) {
        var date = new Date(obj);
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        return y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length);
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          sums[index] = '';
          if (index === 0) {
            return;
          }
          if (index === 1) {
            sums[index] = '合计';
            return;
          }
          if (column.property == 'costtotalmoney') {
            sums[index] = this.$numeric(this.subData.costtotalmoney, 3);
          }else if (column.property == 'rebatemoney') {
            sums[index] = this.$numeric(this.subData.rebatemoney, 2);
          }else if (column.property == 'rebatepercent') {
            sums[index] = this.$numeric(this.subData.rebatepercent, 3);
          }else if (column.property == 'realmoney') {
            sums[index] = this.$numeric(this.subData.realmoney, 3);
          }else if (column.property == 'totalnumber') {
            sums[index] = this.subData.totalnumber;
          }
        });
        this.temp = sums
        return sums;
      },
      //查询条件的选择供应商
      showSelectAllPCustomer() {
        if (this.isClickEvent) {
          this.unitgroup = 3
          this.$refs.externaldeptsel.show(3, "选择供应商")
        } else {
          this.isClickEvent = true
        }
      },
      //查询条件的选择供应商或者门店之后执行
      afterSelExternalDept(customerserial, customername, row) {
        if (this.unitgroup == 3) {//选择供应商
          this.pcustomer = customername
          this.pcustomerserial = customerserial
          this.bindGrid()
        }
      },
      //查看订单
      lookdingdan(item) {
        var serial = item["hetongserial"]
        if (!serial) {
          return;
        }

        switch (serial.substring(0, 2)) {
          case "78":
            this.$refs.BaoSunDetail.show(serial);
            break;
          case "79":
            this.$refs.StorageBadOut.show(serial);
            break;
          default:
            let row = {
              erpserial: serial
            }
            this.$refs.DataContactEdit.initData(row)
            this.$refs.DataContactEdit.show()
            break;
        }
      },
      setBeiZhu(row) {
        if(!row.erpserial) return;
        var arrBeiZhu = [];
        var existDuiz = false;
        var showMessage = {msg: "", type: "对账", date: "", uname: "对账"};
        if (row.remark) {
          try {
            arrBeiZhu = JSON.parse(row.remark.replace(new RegExp("\n", "gm"), ""))
            for (let i in arrBeiZhu) {
              var item = arrBeiZhu[i];
              if ('对账' == item.type) {
                existDuiz = true;
                showMessage = item;
              }
            }
          } catch (ex) {
          }
        }

        this.$prompt('', '请输入备注', {
          inputValue: showMessage.msg,
          confirmButtonText: '保存',
          cancelButtonText: '取消',
        }).then(({value}) => {
          showMessage.msg = value;
          if (!existDuiz) {
            arrBeiZhu.push(showMessage);
          }
          row.remark=JSON.stringify(arrBeiZhu);
          updateStatus({erpserial:row.erpserial,remark:row.remark}).then(respMSG=>{
            this.$message({type: 'success',message: '保存成功！' });
          })
        }).catch(() => {
        });
      },
      //查看采购单
      lookbuyorderdetail(row, isbuyorder) {
        this.$refs.BuyorderDetail.initData(row, 1)
        this.$refs.BuyorderDetail.show();
      },
      selectorder(row) {//选择订单信息
        printingbuy({"ugg": "{\"erpserial1\":\"" + row.erpserial + "\",\"isbuyorder\":1}"}).then(response => {
          if (response.data.code == 0) {
            this.$emit('afterSelect', response.data.obj);
            this.dialogstoreVisible = false
          }
        })
      },
      show() {
        this.dialogstoreVisible = true
        this.showPackageSize = false
      },
      initPriceData(row) {
        this.priceSub=true;
        this.checkall = false
        this.showduizhang = false
        this.datetype = 3
        this.searchstatus='1';
        this.htqd = row.htqd.substr(0,10)
        this.jhjgrq = row.jhjgrq.substr(0,10)
        this.pcustomerserial = row.customerserial
        this.pcustomer = row.customername
        this.showPackageSize = false
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = true
        this.applybydserial = 'all'
        this.buycontractguid=row.unitguid;
        this.categorycode = ''
        this.categoryname = ''

        this.bindGrid();
      },
      initData(row, datetype, searchdatevalue1, searchdatevalue) {
        this.priceSub=false;
        this.checkall = false
        this.showduizhang = true
        this.datetype = datetype
        this.searchdatevalue = searchdatevalue
        this.searchdatevalue1 = searchdatevalue1
        this.pcustomerserial = row.applybydserial
        this.pcustomer = row.applybydname
        this.searchstatus = ''
        this.showPackageSize = false
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = true
        this.showzero=row.showzero;
        this.applybydserial = 'all'
        this.categorycode = ''
        this.categoryname = ''
        if(row.otherparam) {
          if (row.otherparam.searchstatus)
            this.searchstatus = row.otherparam.searchstatus;//到货状态
          if (row.otherparam.seedcode)
            this.seedcode = row.otherparam.seedcode;
          if (row.otherparam.seedname)
            this.seedname = row.otherparam.seedname;
          if (row.otherparam.categorycode)
            this.categorycode = row.otherparam.categorycode;
          if (row.otherparam.categoryname)
            this.categoryname = row.otherparam.categoryname;
        }
        this.bindGrid();
      },
      afertupdate(row, costprice,price) {
        for (let i in this.tableData) {
          if (this.tableData[i].erpserial == row.erpserial && this.tableData[i].seedcode == row.seedcode && (!row.packagesize || row.packagesize == this.tableData[i].packagesize)) {
            this.tableData[i].costprice = costprice;
            this.tableData[i].costtotalmoney = costprice * this.tableData[i].totalnumber

            this.tableData[i].price = price;
            this.tableData[i].totalmoney = price * this.tableData[i].totalnumber
            break;
          }
        }
      },
      updatecostpirce(row) {
        if(this.$route.query.bimanage)
          return;
        this.$refs.UpdateCostPrice.show(row)
      },
      bindGrid() {
        this.loadData(false);
      },
      loadData(IsLoad, qrduizhang) {
        if (IsLoad || qrduizhang)
          this.tableDataExcel = []
        else {
          this.tableData = []
          this.subData = [];
        }

        var bDate;
        var eDate;
        if (this.priceSub) {
          bDate = this.htqd;
          eDate = this.jhjgrq;
        } else {
          if(!this.searchdatevalue1[0]) return;
          var startDate = new Date(this.searchdatevalue1[0]);
          var endDate = new Date(this.searchdatevalue1[1]);
          bDate = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + "-" + startDate.getDate();
          eDate = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + "-" + endDate.getDate();
        }
        var offset = (this.pagination.currentPage - 1) * this.pagination.pageSize;
        var limit = this.pagination.pageSize;
        if (IsLoad || qrduizhang) {
          offset = 0;
          limit = 0;
        }
        supplierDeptList({
          offset: offset,
          limit: limit,
          casefvid: this.searchdatevalue,
          pcustomerserial: this.pcustomerserial,
          ifsend: this.searchstatus,
          needpackagesize: this.showPackageSize || qrduizhang ? 1 : 0,
          searchtext: this.searchtext,
          seedcode: this.seedcode,
          categorycode: this.categorycode,
          datetype: this.searchstatus == '-1' ? '3' : this.datetype,
          begindate: bDate,
          enddate: eDate,
          cangkucode: this.cangkucode,
          tracknum: this.tracknum,
          logisticstracknum: this.logisticstracknum,
          buycontractguid: this.buycontractguid,
          showzero: this.showzero ? 1 : null,
          Y: !this.showPackageSize || this.Y == '' ? '' : ('\"Y\":\"' + parseFloat(this.Y).toFixed(2) + '\"'),
          X: !this.showPackageSize || this.X == '' ? '' : ('\"X\":\"' + parseFloat(this.X).toFixed(2) + "\""),
        }).then(request => {
          //console.log(JSON.stringify(request.data.obj))
          var th = this.dialogtableHeight(195);
          this.eltableheight = this.eltableheight == th ? (th - 1) : th;
          if (IsLoad) {
            this.tableDataExcel = request.data.obj.rows
            if (qrduizhang) {
              this.$refs.SelDate.show(this.tableDataExcel, this.pcustomerserial, this.pcustomer)
            } else
              this.excelPortAfterLoad();
          } else {
            for (let i = 0; i < request.data.obj.rows.length; i++) {
              var rowd = request.data.obj.rows[i];
              rowd.costprice = rowd.costtotalmoney / rowd.totalnumber;
              rowd.price = rowd.totalmoney / rowd.totalnumber;
              rowd.realmoney = this.getRealmoney(rowd);
            }
            this.tableData = request.data.obj.rows
            this.pagination.total = request.data.obj.total
            this.subData = request.data.subnum;
            this.subData.realmoney = this.getRealmoney(this.subData);
            this.showcontract = (this.subData.rebatemoney || this.subData.rebatepercent);
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      getRealmoney(row){
        return row.costtotalmoney-(row.rebatemoney?row.rebatemoney:0)-(row.rebatepercent?row.rebatepercent:0);
      },
      changeStatus() {
      },
      looklog() {
        this.$refs.SelDateLog.show();
        this.$refs.SelDateLog.initForm(this.searchdatevalue, this.pcustomerserial);
      }
    },
    mounted() {
      if (!this.$route.query.bimanage) {
        this.loadexcel = true;
      } else {
        this.loadexcel = this.$route.query.excel ? true : false;
      }
      this.searchjxs = '';
      this.searchdatevalue = "";
      this.pickerOptions2.shortcuts = pickerShortCuts();
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.applybydserial = 'all'
      this.cusandptbyind();//仓库的方法
    },
    components: {
      CstagreementEdit,
      BuyorderDetail,
      ExternaldeptSel,
      UpdateCostPrice,
      SelDate,
      JxcgooddetailSel,
      SelDateLog,
      BaoSunDetail,
      StorageBadOut,
      JxcgoodscategorySel
    }
  }
</script>

<style>
  .duizhang {
    margin-right: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/StoreDetailListSupplySee.vue